import { useEffect, useState } from "react";
import { api, apiError } from "@/lib/apiClient";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import { Download, FileText, Image as ImageIcon, Landmark, Loader2, Users } from "lucide-react";

const ENTE_CODES = ["rc_economia_solidale", "infortuni_economia_solidale", "multirischi_beni", "mrv_volontariato", "cat_nat_impresa", "d_o"];
const KIT = {
  persone: { titolo: "Kit per volontari, soci e dipendenti", Icon: Users, nota: "le soluzioni per le persone" },
  enti: { titolo: "Kit per gli enti aderenti", Icon: Landmark, nota: "le soluzioni per gli enti" },
};

const Kit = ({ accordo, target }) => {
  const [busy, setBusy] = useState("");
  const attivi = Object.entries(accordo.prodotti_config || {}).filter(([, c]) => c?.attivo).map(([k]) => k);
  if (!attivi.some((c) => ENTE_CODES.includes(c) === (target === "enti"))) return null;
  const { titolo, Icon, nota } = KIT[target];
  const scarica = async (formato) => {
    setBusy(formato);
    try {
      const { data } = await api.get(`/admin/accordi/${accordo.id}/kit-${target}?formato=${formato}&origin=${encodeURIComponent(window.location.origin)}`, { responseType: "blob" });
      const l = document.createElement("a"); l.href = URL.createObjectURL(data); l.download = `kit-${target}-${accordo.slug}.${formato}`; l.click();
    } catch (e) { toast.error(apiError(e)); } finally { setBusy(""); }
  };
  return (
    <div className="w-full space-y-2 border-t pt-3 text-center" data-testid={`kit-${target}`}>
      <div className="flex items-center justify-center gap-1.5 text-sm font-medium text-forest"><Icon className="h-4 w-4 text-terracotta" />{titolo}</div>
      <p className="text-xs text-muted-foreground">Solo QR alla pagina dell'accordo e {nota}: nessun prezzo né codice.</p>
      <div className="flex justify-center gap-2">
        <Button size="sm" variant="outline" onClick={() => scarica("pdf")} disabled={!!busy} className="gap-1" data-testid={`kit-${target}-pdf`}>{busy === "pdf" ? <Loader2 className="h-3.5 w-3.5 animate-spin" /> : <FileText className="h-3.5 w-3.5" />}Locandina A4</Button>
        <Button size="sm" variant="outline" onClick={() => scarica("png")} disabled={!!busy} className="gap-1" data-testid={`kit-${target}-png`}>{busy === "png" ? <Loader2 className="h-3.5 w-3.5 animate-spin" /> : <ImageIcon className="h-3.5 w-3.5" />}Immagine social</Button>
      </div>
    </div>
  );
};

// QR della pagina accordo + kit locandina/immagine per persone ed enti.
export const QrBox = ({ accordo }) => {
  const [src, setSrc] = useState("");
  useEffect(() => {
    api.get(`/admin/accordi/${accordo.id}/qr?origin=${encodeURIComponent(window.location.origin)}`, { responseType: "blob" })
      .then(({ data }) => setSrc(URL.createObjectURL(data))).catch((e) => toast.error(apiError(e)));
  }, [accordo.id]);
  const scarica = () => { const l = document.createElement("a"); l.href = src; l.download = `qr-${accordo.slug}.png`; l.click(); };
  return (
    <div className="flex flex-col items-center gap-3 rounded-xl border p-4" data-testid="qr-box">
      {src ? <img src={src} alt="QR accordo" className="h-48 w-48" data-testid="qr-img" /> : <Loader2 className="h-6 w-6 animate-spin" />}
      <div className="text-xs text-muted-foreground">Porta a /accordi/{accordo.slug} (il codice va inserito)</div>
      <Button size="sm" variant="outline" onClick={scarica} disabled={!src} className="gap-1" data-testid="qr-download"><Download className="h-3.5 w-3.5" />Solo QR (PNG)</Button>
      <Kit accordo={accordo} target="persone" />
      <Kit accordo={accordo} target="enti" />
    </div>
  );
};
